import FreeTierRebrand from '@/assets/image/free-to-pay/free-tier-svg/free-tier-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const FreeTierSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'free tier', ...rest } = props;

  return <Image src={FreeTierRebrand} alt={alt} {...rest} />;
};
